import { atom } from "recoil";

export const accountsState = atom({
    key: 'accountsState',
    default: []
})

export const accountsFilterState = atom({
    key: 'accountsFilterState',
    default: ''
})